import { useQuery } from "@tanstack/react-query";

import { getActorsActorIDActorVoicesActorVoiceID } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { ACTOR_VOICES_QUERY_KEYS } from "./actorVoicesQueryKeys";

export function useActorVoiceDetailQuery(
  actorID?: string,
  actorVoiceID?: string,
) {
  return useQuery({
    queryKey: ACTOR_VOICES_QUERY_KEYS.detail(actorID!, actorVoiceID!),
    queryFn: processResponse(() =>
      getActorsActorIDActorVoicesActorVoiceID(actorVoiceID!, actorID!),
    ),
    enabled: !!actorID && !!actorVoiceID,
  });
}
